<template>
  <div v-if="!loadingLanding && landing && landing.id" class="card">
    <div v-if="!hasPermission" class="card-body" id="card-body-1">
      <p class="m-0 p-0">{{ noPermissionMessage }}</p>
    </div>
    <div v-else class="card-body" id="card-body-2">
      <h5 class="h5 mt-0">Privacy &amp; Policy</h5>
      <TextInput v-model="landing.settings.legals.privacy.label" label="Label" />
      <div class="ne-switch-wrap mt-3 mb-3">
        <switches v-model="landing.settings.legals.privacy.use_link" theme="custom" color="blue" />
        <label class="font-size-12">Use Link</label>
      </div>
      <template v-if="landing.settings.legals.privacy.use_link">
        <TextInput v-model="landing.settings.legals.privacy.link" label="Link" placeholder="https://example.com" />
        <div class="ne-switch-wrap mt-3 mb-3">
          <switches v-model="landing.settings.legals.privacy.OpenInNewWindow" theme="custom" color="blue" />
          <label class="font-size-12">Open in New Window</label>
        </div>
      </template>
      <div v-else class="form-group">
        <label>Content</label>
        <Editor v-model="landing.settings.legals.privacy.content" />
      </div>
      <h5 class="h5 mt-4">Terms of Services</h5>
      <TextInput v-model="landing.settings.legals.service.label" label="Label" />
      <div class="ne-switch-wrap mt-3 mb-3">
        <switches v-model="landing.settings.legals.service.use_link" theme="custom" color="blue" />
        <label class="font-size-12">Use Link</label>
      </div>
      <template v-if="landing.settings.legals.service.use_link">
        <TextInput v-model="landing.settings.legals.service.link" label="Link" placeholder="https://example.com" />
        <div class="ne-switch-wrap mt-3 mb-3">
          <switches v-model="landing.settings.legals.service.OpenInNewWindow" theme="custom" color="blue" />
          <label class="font-size-12">Open in New Window</label>
        </div>
      </template>
      <div v-else class="form-group">
        <label>Content</label>
        <Editor v-model="landing.settings.legals.service.content" />
      </div>
      <b-form-group class="mt-3 mb-0 text-right">
        <b-button variant="primary" class="inline-button" :disabled="loadingAction || staticLanding.restoring" @click="saveSettings">
          <b-spinner v-if="loadingAction" small /><label>Save</label>
        </b-button>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { NO_PERMISSION_MESSAGE, PERMISSIONS } from '@src/permissions'
export default {
  props: {
    staticLanding: { type: [Object], default: null, required: true }
  },
  data() {
    return {
      permissionsHelper: PERMISSIONS,
      noPermissionMessage: NO_PERMISSION_MESSAGE,
      landing: null,
      loadingLanding: false,
      loadingAction: false
    }
  },
  computed: {
    userPermissions() { return this.$store.getters['auth/userPermissions'] },
    hasPermission() {
      return this.userPermissions.includes(this.permissionsHelper.EDIT_PRIVACYTERMS)
    }
  },
  mounted() {
    this.initLanding()
  },
  methods: {
    initLanding() {
      if (!this.staticLanding || !this.staticLanding.id) return
      this.loadingLanding = true
      this.landing = JSON.parse(JSON.stringify(this.staticLanding))
      if (!this.landing.settings) {
        this.landing = {
          ...this.landing,
          settings: {}
        }
      }
      if (!this.landing.settings.legals) {
        this.landing.settings = {
          ...this.landing.settings,
          legals: {}
        }
      }
      if (!this.landing.settings.legals.privacy) {
        this.landing.settings.legals = {
          ...this.landing.settings.legals,
          privacy: {}
        }
      }
      if (!this.landing.settings.legals.privacy.hasOwnProperty('label')) {
        this.landing.settings.legals.privacy = {
          ...this.landing.settings.legals.privacy,
          label: null
        }
      }
      if (!this.landing.settings.legals.privacy.hasOwnProperty('OpenInNewWindow')) {
        this.landing.settings.legals.privacy = {
          ...this.landing.settings.legals.privacy,
          OpenInNewWindow: true
        }
      }
      if (!this.landing.settings.legals.privacy.hasOwnProperty('use_link')) {
        this.landing.settings.legals.privacy = {
          ...this.landing.settings.legals.privacy,
          use_link: false
        }
      }
      if (!this.landing.settings.legals.privacy.hasOwnProperty('link')) {
        this.landing.settings.legals.privacy = {
          ...this.landing.settings.legals.privacy,
          link: null
        }
      }
      if (!this.landing.settings.legals.privacy.hasOwnProperty('content')) {
        this.landing.settings.legals.privacy = {
          ...this.landing.settings.legals.privacy,
          content: null
        }
      }
      if (!this.landing.settings.legals.service) {
        this.landing.settings.legals = {
          ...this.landing.settings.legals,
          service: {}
        }
      }
      if (!this.landing.settings.legals.service.hasOwnProperty('label')) {
        this.landing.settings.legals.service = {
          ...this.landing.settings.legals.service,
          label: null
        }
      }
      if (!this.landing.settings.legals.service.hasOwnProperty('OpenInNewWindow')) {
        this.landing.settings.legals.service = {
          ...this.landing.settings.legals.service,
          OpenInNewWindow: true
        }
      }
      if (!this.landing.settings.legals.service.hasOwnProperty('use_link')) {
        this.landing.settings.legals.service = {
          ...this.landing.settings.legals.service,
          use_link: false
        }
      }
      if (!this.landing.settings.legals.service.hasOwnProperty('link')) {
        this.landing.settings.legals.service = {
          ...this.landing.settings.legals.service,
          link: null
        }
      }
      if (!this.landing.settings.legals.service.hasOwnProperty('content')) {
        this.landing.settings.legals.service = {
          ...this.landing.settings.legals.service,
          content: null
        }
      }
      this.loadingLanding = false
    },
    saveSettings() {
      this.loadingAction = true
      this.$store
        .dispatch('landing/updateSettings', this.landing)
        .then(() => {
          this.loadingAction = false
          this.$emit('refreshLanding')
        })
        .catch(() => this.loadingAction = false)
    }
  }
}
</script>